/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAppointmentExchangeRequest
 */
export interface UpdateAppointmentExchangeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAppointmentExchangeRequest
     */
    requestedPurposeKeys: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentExchangeRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the UpdateAppointmentExchangeRequest interface.
 */
export function instanceOfUpdateAppointmentExchangeRequest(value: object): value is UpdateAppointmentExchangeRequest {
    if (!('requestedPurposeKeys' in value) || value['requestedPurposeKeys'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function UpdateAppointmentExchangeRequestFromJSON(json: any): UpdateAppointmentExchangeRequest {
    return UpdateAppointmentExchangeRequestFromJSONTyped(json, false);
}

export function UpdateAppointmentExchangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentExchangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'requestedPurposeKeys': json['requestedPurposeKeys'],
        'note': json['note'],
    };
}

export function UpdateAppointmentExchangeRequestToJSON(json: any): UpdateAppointmentExchangeRequest {
    return UpdateAppointmentExchangeRequestToJSONTyped(json, false);
}

export function UpdateAppointmentExchangeRequestToJSONTyped(value?: UpdateAppointmentExchangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestedPurposeKeys': value['requestedPurposeKeys'],
        'note': value['note'],
    };
}

